/**
 * 計算機模組
 * @param rawList 金額字串陣列
 */

import { isNumber } from 'lodash';

import Decimal, { Numeric } from 'decimal.js-light';
import {
  checkOnlyNumberAndDot,
  checkVariableIsempty,
} from './variable-checkers';

//避免 new Decimal()接到[null, undefined, '']報錯！
const newDecimal = (v: Numeric) => {
  try {
    return new Decimal(v);
  } catch {
    return new Decimal(0);
  }
};

/**
 * 計算金額加總
 * @param rawList
 * @param returnDecimal
 * @param fixedNumber
 * @returns
 */
const calculateAmount = (
  rawList: string[] | number[],
  returnDecimal?: boolean | null, //是否以decimal回傳false:string true:Decimal
  fixedNumber?: number //是否僅取小數位至fixedNumber位
): Decimal | number => {
  returnDecimal = returnDecimal === true ? true : false;

  let total = newDecimal(0);
  rawList.forEach((amount) => {
    if (
      checkVariableIsempty(amount) ||
      !checkOnlyNumberAndDot(String(amount))
    ) {
      total = total.plus(newDecimal(0));
    } else {
      total = total.plus(newDecimal(amount));
    }
  });

  if (returnDecimal === false) {
    //set amount fixed
    if (isNumber(fixedNumber) === true) {
      const fixed = isNumber(fixedNumber) === true ? fixedNumber : 0;
      total = newDecimal(total.toFixed(fixed));
    } else {
      total = newDecimal(total.toFixed(2));
    }
    return total.toNumber();
  }
  if (returnDecimal === true) {
    //set amount fixed
    if (isNumber(fixedNumber) === true) {
      const fixed = isNumber(fixedNumber) === true ? fixedNumber : 0;
      total = newDecimal(total.toFixed(fixed));
    }
    return total;
  }
  return total;
};
/**
 * 計算金額相減a-b-c-d
 * @param rawList
 * @param returnDecimal
 * @param fixedNumber
 * @returns
 */
const calculateAmountMinius = (
  rawList: string[] | number[],
  returnDecimal?: boolean | null, //是否以decimal回傳false:string true:Decimal
  fixedNumber?: number //是否僅取小數位至fixedNumber位
): Decimal | number => {
  returnDecimal = returnDecimal === true ? true : false;

  let total = newDecimal(0);

  rawList.forEach((amount, index) => {
    if (index === 0) {
      if (
        checkVariableIsempty(amount) ||
        !checkOnlyNumberAndDot(String(amount))
      ) {
        total = total.plus(newDecimal(0));
      } else {
        total = total.plus(newDecimal(amount));
      }
    } else {
      total = total.minus(
        checkVariableIsempty(amount) ||
          !checkOnlyNumberAndDot(String(amount)) === true
          ? newDecimal(0)
          : newDecimal(amount)
      );
    }
  });

  if (returnDecimal === false) {
    //set amount fixed
    if (isNumber(fixedNumber) === true) {
      const fixed = isNumber(fixedNumber) === true ? fixedNumber : 0;
      total = newDecimal(total.toFixed(fixed));
    } else {
      total = newDecimal(total.toFixed(2));
    }
    return total.toNumber();
  }
  if (returnDecimal === true) {
    //set amount fixed
    if (isNumber(fixedNumber) === true) {
      const fixed = isNumber(fixedNumber) === true ? fixedNumber : 0;
      total = newDecimal(total.toFixed(fixed));
    }
    return total;
  }
  return total;
};
/**
 * 乘法工具 a*b*c
 * @param rawList
 * @param returnDecimal
 * @param fixedNumber
 * @returns
 */
const calculateMul = (
  rawList: string[] | number[],
  returnDecimal?: boolean | null, //是否以decimal回傳false:string true:Decimal
  fixedNumber?: number //是否僅取小數位至fixedNumber位
): Decimal | number => {
  returnDecimal = returnDecimal === true ? true : false;

  let total = newDecimal(1);
  rawList.forEach((amount) => {
    if (
      checkVariableIsempty(amount) ||
      !checkOnlyNumberAndDot(String(amount))
    ) {
      total = total.mul(newDecimal(1));
    } else {
      total = total.mul(newDecimal(amount));
    }
  });

  if (returnDecimal === false) {
    //set amount fixed
    if (isNumber(fixedNumber) === true) {
      const fixed = isNumber(fixedNumber) === true ? fixedNumber : 0;
      total = newDecimal(total.toFixed(fixed));
    } else {
      total = newDecimal(total.toFixed(2));
    }
    return total.toNumber();
  }
  if (returnDecimal === true) {
    //set amount fixed
    if (isNumber(fixedNumber) === true) {
      const fixed = isNumber(fixedNumber) === true ? fixedNumber : 0;
      total = newDecimal(total.toFixed(fixed));
    }
    return total;
  }
  return total;
};
/**
 * 除法工具 a/b/c/d
 * @param rawList
 * @param returnDecimal
 * @param fixedNumber
 * @returns
 */
const calculateDivide = (
  rawList: string[] | number[],
  returnDecimal?: boolean | null, //是否以decimal回傳false:string true:Decimal
  fixedNumber?: number //是否僅取小數位至fixedNumber位
): Decimal | number => {
  let total = new Decimal(rawList?.[0]);

  rawList.slice(1).forEach((amount) => {
    if (
      !checkVariableIsempty(amount) &&
      checkOnlyNumberAndDot(String(amount))
    ) {
      total = total.div(new Decimal(amount));
    }
  });

  if (returnDecimal === false) {
    const fixed = isNumber(fixedNumber) ? fixedNumber : 2;
    total = total.toFixed(fixed) as any;
    return Number(total);
  }

  if (returnDecimal === true) {
    if (isNumber(fixedNumber)) {
      total = new Decimal(total.toFixed(fixedNumber));
    }
    return total;
  }

  return total;
};

export {
  calculateAmount,
  calculateAmountMinius,
  calculateDivide,
  calculateMul,
  newDecimal,
};
